module.exports = __webpack_public_path__ + "es.4398afa5eb37f70f9e2f.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/es.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/es.svg
// module chunks = styles